import zappy from "@zappy-ride/library.react.components";
import { CopyShareLink } from './CopyShareLink';

export * from "./CopyShareLink";

zappy.FactoryInstance.registerComponent(CopyShareLink);
